/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Exercises_LoadingInputs */

const en_us2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching exercises…`)
};

const pt_br2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando exercícios…`)
};

const es_419_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando ejercicios…`)
};

const pt_pt2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A pesquisar exercícios…`)
};

const fr_fr2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche d'exercices…`)
};

const de_de2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen werden gesucht…`)
};

const it_it2_search_exercises_loading = /** @type {(inputs: Search_Exercises_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca degli esercizi…`)
};

/**
* | output |
* | --- |
* | "Searching exercises…" |
*
* @param {Search_Exercises_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_exercises_loading = /** @type {((inputs?: Search_Exercises_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Exercises_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_exercises_loading(inputs)
	if (locale === "es-419") return es_419_search_exercises_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_search_exercises_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_search_exercises_loading(inputs)
	if (locale === "de-DE") return de_de2_search_exercises_loading(inputs)
	if (locale === "it-IT") return it_it2_search_exercises_loading(inputs)
	return en_us2_search_exercises_loading(inputs)
});
export { search_exercises_loading as "search.exercises_loading" }